import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Proforma Report</h1>
            <p className="mb-0">List of proforma reports</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/proforma/view-header.js